export default __webpack_public_path__ + "static/media/PEUGEOT.e4b58045.png";